export class DocumentDownload {
  public id: string;
  public name: string;
  public icon?: string;
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/communication/model/document-download.model.ts